import axios from "axios";

// 测试API
const base_url = "https://www.sh-million.com";
// const base_url = 'http://101.133.222.105'

//线上API
// const base_url = `${base_url}'

export default {
  // getCity(callback) {
  //     axios.get('https://cdn.chezhentong.com/area.json').then((res) => {
  //         callback(res)
  //     })
  // },

  getIntroductionContent(callback) {
    axios
      .get(
        `${base_url}/v1/api/copywriting?_where=(copy_writing_location,is,Introduction)`
      )
      .then((res) => {
        callback(res.data);
      });
  },

  getTTSToken(id, callback) {
    axios.get(`${base_url}/tts/token`).then((res) => {
      console.log(res);
      console.log(res.data);
      callback(res.data);
    });
  },

  getPostInfoById(id, callback) {
    axios.get(`${base_url}/v2/api/Post?_where=(id,eq,${id})`).then((res) => {
      callback(res.data);
    });
  },
  getTipsList(callback) {
    axios
      .get(
        `${base_url}/v2/api/Post?_where=(c_is_delete,is,false)~and(post_type,eq,2)&_sort=-id`
      )
      .then((res) => {
        callback(res.data);
      });
  },
  getNewsList(callback) {
    axios
      .get(
        `${base_url}/v2/api/Post?_where=(c_is_delete,is,false)~and(post_type,eq,1)&_sort=-c_addition_unix`
      )
      .then((res) => {
        callback(res.data);
      });
  },

  getWebMenu(callback) {
    axios
      .get(`${base_url}/v2/api/WebMenu?_where=(c_is_delete,is,false)`)
      .then((res) => {
        callback(res.data);
      });
  },

  getProductsType(callback) {
    axios
      .get(`${base_url}/v1/api/producttype?_sort=-c_addition_date`)
      .then((res) => {
        callback(res.data);
      });
  },

  getProducts(callback) {
    axios.get(`${base_url}/v1/api/product`).then((res) => {
      callback(res.data);
    });
  },

  getProductsById(id, callback) {
    axios
      .get(
        `${base_url}/v1/api/product?_where=(product_type_id,is,${id})&_sort=-c_addition_date`
      )
      .then((res) => {
        callback(res.data);
      });
  },

  getQuestionsType(callback) {
    axios
      .get(`${base_url}/v1/api/quesstiontype?_sort=-c_addition_date`)
      .then((res) => {
        callback(res.data);
      });
  },

  getQuestionsById(id, callback) {
    // axios.get(`${base_url}/v1/api/faqs?_where=(category_id,is,${id})`).then((res) => {
    axios
      .get(
        `${base_url}/v1/api/faqs?_where=(category_id,is,${id})&_sort=-c_addition_date`
      )
      .then((res) => {
        callback(res.data);
      });
  },

  getSearchQuestions(value, callback) {
    axios.get(`${base_url}/v1/api/faqs/search/${value}`).then((res) => {
      callback(res.data);
    });
  },

  getTechCenterInfo(callback) {
    axios
      .get(
        `${base_url}/v1/api/copywriting?_where=(copy_writing_location,is,TechCenter)`
      )
      .then((res) => {
        callback(res.data);
      });
  },

  getProductsCenterInfo(callback) {
    axios
      .get(
        `${base_url}/v1/api/copywriting?_where=(copy_writing_location,is,Produces)`
      )
      .then((res) => {
        callback(res.data);
      });
  },

  getPartnerInfo(callback) {
    axios
      .get(
        `${base_url}/v1/api/copywriting?_where=(copy_writing_location,is,Partner)`
      )
      .then((res) => {
        callback(res.data);
      });
  },

  postUserManage(formData, callback) {
    axios.post(`${base_url}/v1/api/sendemail`, formData).then((res) => {
      callback(res.data);
    });
  },

  getProductsCenterInfoById(id, callback) {
    axios
      .get(
        `${base_url}/v1/api/copywriting?_where=(copy_writing_location,is,Produces)~and(product_type_id,is,${id})`
      )
      .then((res) => {
        callback(res.data);
      });
  },

  getShowImage(callback) {
    axios.get(`${base_url}/v1/api/showimage`).then((res) => {
      callback(res.data);
    });
  },

  getAddress(callback) {
    axios.get(`${base_url}/v1/api/aboutus`).then((res) => {
      callback(res.data);
    });
  },

  getFileDown(callback) {
    axios.get(`${base_url}/v1/api/filedata`).then((res) => {
      callback(res.data);
    });
  },

  getVideo(callback) {
    axios.get(`${base_url}/v1/api/video`).then((res) => {
      callback(res.data);
    });
  },

  getGearModuleList(callback) {
    axios
      .get(`${base_url}/v1/api/gearmodule?_sort=-c_addition_date`)
      .then((res) => {
        callback(res.data);
      });
  },
  getProductsByGuid(guid, callback) {
    axios
      .get(`${base_url}/v1/api/product?_where=(guid,eq,${guid})`)
      .then((res) => {
        callback(res.data);
      });
  },
};

// getProductsById(id, callback) {
//     axios.get(`${base_url}/v1/api/product?_where=(product_type_id,is,${id})&_sort=-c_addition_date`).then((res) => {
//         callback(res.data)
//     })
// },
